// extracted by mini-css-extract-plugin
export default {"deleteButton":"etuHe7yhFhgIoPITTfNK","focus-visible":"RT7ykoz73qq8zCUMutUc"};